module.exports = __webpack_public_path__ + "media/images/icon__calendar@2x-d528c4a92300208f1c378cfb9af4c781.png";